"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var filebar_menu_html_1 = __importDefault(require("./filebar-menu.html"));
(function (module) {
    function ShareMenuController($filter, managePublicReportModal, downloadHelper, scheduleEmailModal, triggerOverrides, OVERRIDE_EVENTS, env, FILE_TYPES, metricsService, $location) {
        var $ctrl = this, translate = $filter('translate'), permissions = env.get('permissions');
        var configFlags = triggerOverrides({
            event: OVERRIDE_EVENTS.CONFIG_FLAGS,
            sync: true,
            data: {}
        });
        angular.extend($ctrl, {
            id: 'SHARE',
            label: translate('SHARE'),
            hideMenu: configFlags.disableSharing,
            getMenuItems: function () {
                var menuItems = [
                    {
                        label: translate('DOWNLOAD_PDF'),
                        icon: 'icon-pdffile-lg',
                        action: function () {
                            downloadHelper.downloadPDF();
                            metricsService.exportComplete(FILE_TYPES.PDF, metricsService.EXPORT_CALL_SOURCE.SHARE);
                        },
                        replaceCheck: true
                    }
                ];
                // Adds an easy way to test pptx exports locally.
                if ($location.search().addPPTXExportOption) {
                    menuItems.push({
                        label: translate('DOWNLOAD_PPTX'),
                        icon: 'icon-download-lg',
                        action: function () {
                            downloadHelper.downloadPPTX();
                        },
                        replaceCheck: true
                    });
                }
                if ((permissions || {}).enablePublicReport) {
                    menuItems = menuItems.concat([
                        {
                            divider: true
                        },
                        {
                            label: translate('DASHBOARD_MENU.MANAGE_PUBLIC_REPORT'),
                            icon: 'icon-collaborate-lg',
                            action: function () {
                                managePublicReportModal.show(metricsService.CALL_SOURCE.DROPDOWN);
                            },
                            replaceCheck: true
                        },
                    ]);
                }
                if (!_.find(menuItems, 'divider')) {
                    menuItems.push({
                        divider: true
                    });
                }
                if ((permissions || {}).accessMailer) {
                    menuItems.push({
                        label: translate('SCHEDULED_EMAIL'),
                        icon: 'icon-envelope-wire',
                        action: scheduleEmailModal.show,
                        replaceCheck: true
                    });
                }
                return menuItems;
            }
        });
    }
    ShareMenuController.$inject = [
        '$filter',
        'prManagePublicReportModal',
        'prDownloadHelper',
        'prScheduleEmailModal',
        'prOverrideTrigger',
        'pr.OVERRIDE_EVENTS',
        'rsEnvironment',
        'pr.EXPORT_FILE_TYPES',
        'prMetricsService',
        '$location'
    ];
    module.component('prShareMenu', {
        controller: ShareMenuController,
        templateUrl: filebar_menu_html_1.default,
        require: {
            fbCtrl: '^^prFilebar'
        }
    });
}(angular.module('qualtrics.pr')));
